import type {
  ReportPreviewOverviewSection,
  ReportPreviewProfile,
} from 'api/analytics-reports/types';

/** TODO(overview-pdf-be): @see overviewPdfExportBackendGaps.ts */
export function resolveReportPreviewOverviewSection(
  profile: ReportPreviewProfile,
): ReportPreviewOverviewSection | undefined {
  return profile.sections.find(
    (section): section is ReportPreviewOverviewSection =>
      section.kind === 'overview',
  );
}

export function isOverviewPreviewProfile(
  profile: ReportPreviewProfile,
): boolean {
  return resolveReportPreviewOverviewSection(profile) != null;
}
